export default __webpack_public_path__ + "spektr_datastudio_logo.75729dae.png";